function Contact() {
    return (
        <div className="flex flex-col justify-center bg-yellow-100 text-center p-8 md:min-h-[30vh]">
            <h1 className="text-3xl my-6 font-bold md:text-5xl">Interested In Learning Piano?</h1>
            <h2 className="border-black border-2 rounded-full ml-auto mr-auto p-3 shadow-2xl bg-white mb-8">Get in touch: +353 87 1197330</h2>
        </div>
    )
}

export default Contact;